import { css } from 'lit';

export const style = css`
	:host {
		display: flex;
		position: relative;
		flex-direction: column;
		height: 100%;
		min-height: 0;
	}

	* {
		box-sizing: border-box;
	}

	.controls {
		display: flex;
		flex-direction: row;
		align-items: center;
		flex: 0;
		border-bottom: 1px solid var(--og-border-color);
	}

	#empty {
		flex: 1;
	}

	#history {
		flex: 0 1 250px;
		padding-right: 4px;
	}

	#ddHistory {
		width: 100%;
		height: 24px;
	}

	.body {
		display: flex;
		flex-direction: column;
		flex: 1;
		min-height: 0;
		position: relative;
	}

	.controls > rp-editor-settings-menu {
		flex: 0 0 auto;
	}

	og-markdown-editor, og-code {
		width: 100%;
		height: 100%;
	}

	og-code-diff {
		display: flex;
		flex: 1;
		min-height: 0;
		overflow: hidden;
	}
`;
